import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { MeterCircleWebElement } from './MeterCircleWebElement';
export { MeterCircleWebElement };

/**
 * Retrieve an instance of [MeterCircleWebElement](../classes/MeterCircleWebElement.html).
 * @example
 * ```javascript
 * import { findMeterCircle } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findMeterCircle(driver, By.id('my-oj-c-meter-circle'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findMeterCircle(driver: DriverLike, by: By): Promise<MeterCircleWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type MeterCircleWebElement
  if (!(webEl instanceof MeterCircleWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'MeterCircleWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findMeterCircle(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${MeterCircleWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-meter-circle', MeterCircleWebElement);
